import { Observable } from 'rxjs';
import { IGroupingCriteriaValueDTO } from '../../../models/grouping-criteria-value.dto';

export abstract class ProfessionsContract {
  abstract get(): Observable<IGroupingCriteriaValueDTO[]>;
}
